import { formatToDateTime } from 'brazilian-values'

import { Box, Flex } from '@grupoboticario/flora-react'

import FormInfo from '@/components/FormInfo/FormInfo'
import PageTitle from '@/components/PageTitle/PageTitle'
import StatusForm from '@/components/StatusForm/StatusForm'
import { useHeaderContext } from '@/context/header'
import { formatCurrency, getCurrencyName } from '@/utils/format/formatCurrency'
import { getBlzStatusLabel } from '@/utils/getIsBlzStatusLabel'
import { getTierLabel } from '@/utils/getTierLabel'

import * as S from './ClubProfile.styles'

const ClubProfile = ({ documentNumber, onUpdate }) => {
  const { member } = useHeaderContext()

  return (
    <Box css={S.outerBoxCss}>
      <PageTitle>Perfil do clube</PageTitle>
      <Flex direction="column" gap="$7">
        <Flex gap="$5" wrap="wrap">
          <FormInfo text={getTierLabel(member.tier)} title="Tier:" color="$statusSuccessNonInteractivePredominant" />
          <FormInfo
            text={String(member.total?.point ?? 0)}
            title="Saldo em pontos:"
            color="$statusSuccessNonInteractivePredominant"
          />
          <FormInfo
            text={formatCurrency(member.total?.value ?? 0)}
            title={`Saldo em ${getCurrencyName()}:`}
            color="$statusSuccessNonInteractivePredominant"
          />
          <FormInfo
            text={member?.lastPurchase?.valueOfYear ? formatCurrency(member?.lastPurchase?.valueOfYear) : '-'}
            title="Valor gasto nos últimos 12 meses:"
            color="$statusSuccessNonInteractivePredominant"
          />
          <FormInfo
            text={member.createdAt ? formatToDateTime(new Date(member.createdAt)) : '-'}
            title="Data do cadastro:"
            color="$statusSuccessNonInteractivePredominant"
          />
          <FormInfo
            text={member.updatedAt ? formatToDateTime(new Date(member.updatedAt)) : '-'}
            title="Data da atualização:"
            color="$statusSuccessNonInteractivePredominant"
          />
          <FormInfo
            text={member.origin?.channel || '-'}
            title="Canal do cadastro:"
            color="$statusSuccessNonInteractivePredominant"
          />
          <FormInfo
            text={member.origin?.originId || '-'}
            title="Loja/Revendedora:"
            color="$statusSuccessNonInteractivePredominant"
          />
          <FormInfo
            text={member.origin?.identifier || '-'}
            title="Criado por:"
            color="$statusSuccessNonInteractivePredominant"
          />
          <FormInfo
            text={getBlzStatusLabel(member?.isBlz)}
            title="Piloto BLZ:"
            color="$statusSuccessNonInteractivePredominant"
          />
        </Flex>
        <StatusForm data={member} documentNumber={documentNumber} onStatusChange={onUpdate} />
      </Flex>
    </Box>
  )
}

export default ClubProfile
